import { useTranslation } from 'react-i18next';
import { ShareDeviceDialogBase } from './ShareDeviceDialogBase';

interface ShareDeviceReservationSuccessDialogContentProps {
  onConfirm: () => void;
}

export const ShareDeviceReservationSuccessDialogContent = ({
  onConfirm,
}: ShareDeviceReservationSuccessDialogContentProps) => {
  const { t } = useTranslation();

  return (
    <ShareDeviceDialogBase>
      <div className="dialog__text">
        <p className="dialog__text-line dialog__text-line-left">
          {t('shareDevice.reservationSuccess.message1')}
          <br />
          {t('shareDevice.reservationSuccess.message2')}
          <br />
          {t('shareDevice.reservationSuccess.message3')}
        </p>
      </div>
      <div className="f4__actions">
        <button className="dialog__btn dialog__btn--ok js-bt-dialog" type="button" onClick={onConfirm}>
          {t('shareDevice.reservationSuccess.okButton')}
        </button>
      </div>
    </ShareDeviceDialogBase>
  );
};


